module.exports = __webpack_public_path__ + "static/media/Sales1.5524d392.png";